import { relationFamily, type RelationFamily } from './families.js'
import { DEFAULT_RESTING_RULE, selectRestingEdges, type RestingRule } from './visibility.js'
import type { ChapterGraph } from './types.js'

/**
 * Archi da mostrare quando il chip di famiglia è attivo: tutti gli archi
 * intra residenti della famiglia se sono pochi (≤ capPerNode*N), altrimenti
 * la regola a riposo applicata al solo sottoinsieme della famiglia.
 */
export function edgesForFamily(
  graph: ChapterGraph,
  family: RelationFamily | 'all',
  rule: RestingRule = DEFAULT_RESTING_RULE,
): Set<string> {
  if (family === 'all') return selectRestingEdges(graph, rule)

  const nodeIds = new Set(graph.nodes.map((n) => n.nodeId))
  const familyEdges = graph.edges.filter(
    (e) =>
      e.scope === 'intra' &&
      nodeIds.has(e.sourceNodeId) &&
      nodeIds.has(e.targetNodeId) &&
      relationFamily(e.relationType) === family,
  )

  const cap = rule.capPerNode * graph.nodes.length
  if (familyEdges.length <= cap) {
    return new Set(familyEdges.map((e) => e.edgeId))
  }

  const subsetGraph: ChapterGraph = { ...graph, edges: familyEdges }
  return selectRestingEdges(subsetGraph, rule)
}
